module.exports = __webpack_public_path__ + "img/1200px-Google-My-Business_logo.svg.5bf2c368.png";